module.exports = __webpack_public_path__ + "static/brands-desktop-56af5bfef697177d11a0eb9eddcfce55.png";